import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-broker-report',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './broker-report.component.html',
  styleUrl: '../profit-report.component.css'
})
export class BrokerReportComponent {
  @Input() reportData: any;
  @Input() forPdf: boolean = false;
}
